import React from "react";
import styled from "styled-components";
import { WmkLink } from "wmk-link";
import { colors } from "../colors";
import { Typography } from "../Typography";

const StyledButton = styled.div`
  a,
  a > * {
    font-size: 16px !important;
    text-transform: uppercase;
    color: ${colors.accentOrange.getHex()};
    transition: all 0.3s ease;
  }
  a:hover,
  a > *:hover {
    color: ${colors.white.getHex()};
    transition: all 0.3s ease;
  }
`;

const TextButton = ({
  to,
  target,
  children
}: {
  to: string;
  target?:
    | "_blank"
    | "blank"
    | "_parent"
    | "parent"
    | "_self"
    | "self"
    | "_top"
    | "top";
  children: React.ReactNode;
}) => {
  return (
    <StyledButton>
      <Typography.BLOCKQUOTE>
        <WmkLink to={to} target={target ? target : undefined}>
          {"< "}
          {children}
        </WmkLink>
      </Typography.BLOCKQUOTE>
    </StyledButton>
  );
};

export default TextButton;
